import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { Grid, Link, Text } from "designSystem/index";
import React from "react";

export default () => (
	<Link href="http://centricsoftware.com" target="_blank">
		<Grid
			alignItems="center"
			container
			spacing={1}
		>
			<Grid item>
				<AllInclusiveIcon />
			</Grid>
			<Grid item>
				<Text text="Centric Software" />
			</Grid>
		</Grid>
	</Link>
);